import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  selectIdToken,
  selectIsAuthenticated,
  selectIsSuperUser
} from 'features/auth/authenticationSlice';

export const useAuth = (): {
  isAuthenticated: boolean;
  idToken: string | null;
  isSuperUser: boolean;
} => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const idToken = useSelector(selectIdToken);
  const isSuperUser = useSelector(selectIsSuperUser);

  return useMemo(
    () => ({ isAuthenticated, idToken, isSuperUser }),
    [isAuthenticated, idToken, isSuperUser]
  );
};
